<template>
  <div class="chatterbox">
    <div class="meta-section">
      <h3>Details</h3>
      <div class="select-container">
        <label for="site">Site</label>
        <select :disabled="!isActive" id="site" v-model="chatterbox.siteId">
          <option value="">Unknown</option>
          <option v-for="site in siteList" v-bind:key="site.id" :value="site.id">{{ site.name }}</option>
        </select>
        <!-- prettier-ignore -->
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z" fill="#999" /></svg>
      </div>
      <div class="select-container">
        <label for="language">Market</label>
        <select :disabled="!isActive" id="language" v-model="chatterbox.languageId">
          <option :value="{ id: '', name: '' }">Unknown</option>
          <option v-for="market in oldMarketList" v-bind:key="market.id" :value="market.id">{{ market.name }}</option>
        </select>
        <!-- prettier-ignore -->
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z" fill="#999" /></svg>
      </div>
    </div>
    <div class="content-section">
      <h3>Content</h3>
      <div class="input-container">
        <label for="url">Website (Full URL)</label>
        <input :disabled="!isActive" class="input" id="url" v-model="chatterbox.url" />
      </div>
      <div class="textarea-container">
        <label>Text ({{ wordCount(chatterbox.content) }} words)</label>
        <textarea :disabled="!isActive" class="textarea" id="content" rows="20" v-model="chatterbox.content"></textarea>
      </div>
    </div>
  </div>
</template>

<script>
import sharedWordCountScript from '@/assets/shared-scripts/wordcount'
import { mapGetters } from 'vuex'
export default {
  created() {
    this.wordCount = sharedWordCountScript.wordCounter
  },
  props: {
    chatterbox: Object,
    adminData: Object,
  },
  computed: {
    ...mapGetters(['oldMarketList', 'siteList', 'linkBuilderAdmins']),
    isActive() {
      return this.chatterbox.status == 'Draft' || this.chatterbox.status == 'Revision Needed' ? true : false
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../assets/shared-styles/checkbox.scss';
@import '../assets/shared-styles/input.scss';
@import '../assets/shared-styles/textarea.scss';
@import '../assets/shared-styles/select.scss';

select {
  height: 2rem;
}
.chatterbox {
  background: white;
}
.meta-section,
.anchors-section,
.content-section {
  position: relative;
  display: grid;
  gap: 1rem 1.5rem;
  padding: 1.5rem;
  h3 {
    font-size: 1rem;
    grid-column: 1 / -1;
    font-weight: 400;
    margin: 0;
  }
  &:before {
    content: '';
    position: absolute;
    top: calc(100%);
    width: 100%;
    height: 1px;
    background: #ebebf2;
  }
}
.meta-section {
  grid-template-columns: auto auto 1fr;
}
</style>
